import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Alert from "sweetalert-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import { Bold } from "../Styles";
import { ButtonStyle } from "../Styles";
import Loader from "../Shared/Loader";
import Util from "../../lib/utils"

import {
  getEmployerJobs as getEmployerJobsAction,
  removeJob as removeJobAction,
} from "../../redux/middleware/job";

import { getUserByToken as getUserByTokenAction } from "../../redux/middleware/user";

const Header = styled.div`
  width: 100%;
  float: left;
  padding: 20px 20px 10px;
  background-color: #f6f7f8;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`

const HeaderTitle = styled.div`
  float: left;
  margin: 0 0 7px;
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  padding: 0;
`

const Icon = styled.button`
  color: #8290a2;
  border-color: #8290a2;
  text-align: center;
  float: right;
  border-radius: 7px;
  margin-left: 4px;
  margin-top: 5px;
  padding: 2px 7px 1px;
`;

const IconLink = Icon.withComponent(Link);
const EditLink = Icon.withComponent("a");

const PostAJobButton = ButtonStyle.withComponent(Link);

const Job = ({job, confirm}) =>
  <tr>
    <td style={{paddingTop: 15}}>
      <Bold>{job.title}</Bold>
    </td>
    <td className="hidden-xs" style={{paddingTop: 15}}>{job.status}</td>
    <td className="hidden-xs" style={{paddingTop: 15}}>
      <i className="fa fa-calendar"></i> {moment(job.created_at).format('MM-DD-YYYY')}
    </td>
    <td className="hidden-xs" style={{paddingTop: 15}}><i className="fa fa-calendar"></i> {
      moment(job.expires_at).format('MM-DD-YYYY')
    }</td>
    <td>
      <div>
        <Icon className="btn_status" alt="trash" onClick={() => confirm(job)} onlyActiveOnIndex>
          <i className="fa fa-trash" />
        </Icon>
        <IconLink className="btn btn_status" alt="applicants" to={`/dashboard/jobs/${job.slug}/applicants`}>
          <i className="fa fa-users" /> {job.applicant_count}
        </IconLink>
        <EditLink className="btn btn_status" alt="edit" href={`/jobs/${job.slug}/edit`}>
          <i className="fa fa-edit" />
        </EditLink>
        <IconLink className="btn btn_status" alt="view" to={`/jobs/${job.slug}`}>
          <i className="fa fa-search" />
        </IconLink>
      </div>
    </td>
  </tr>

const JobTable = ({jobs, confirm, pending}) => {
  if (pending) return <Loader fullScreen vwidth="50vw" show={true} />;
  if (jobs && jobs.length === 0 && !pending) {
    return (
      <div style={{padding: '100px 20px'}}>
        You have not posted any jobs yet. Click <a href="/employers/post-job">here</a>
        &nbsp;to post your first job!
      </div>
    )
  } else {
    return (
      <table cellSpacing="0" cellPadding="0" className="table">
        <thead>
          <tr>
            <th className="bdl_radius" width="40%">Title</th>
            <th className="hidden-xs" width="15%">Status</th>
            <th className="hidden-xs" width="15%">Created</th>
            <th className="hidden-xs" width="11%">Expires</th>
            <th width="20%"></th>
          </tr>
        </thead>
        <tbody>
          {jobs &&
            jobs.map((job, index) => (
              <Job
                key={index}
                confirm={confirm}
                job={job}
                sidebarJobs={jobs.slice(0, 10)}
              />
            ))}
        </tbody>
      </table>
    )
  }
}


class Jobs extends Component {
  constructor(props) {
    super(props);
    this.state = { show: false, jobs: [] };
  }

  componentDidMount() {
    const { getEmployerJobs, user, getUserByToken } = this.props;
    getUserByToken(Util.getUserToken());
    user && getEmployerJobs(user);
  }

  componentWillReceiveProps(nextProps) {
    const { removeJobPending, getEmployerJobs, user, userPending } = this.props;
    if (!nextProps.removeJobPending && removeJobPending) {
      !nextProps.error && getEmployerJobs(user);
    }
    if (!nextProps.userPending && userPending) {
      getEmployerJobs(nextProps.user);
    }
    this.setState({ jobs: nextProps.jobs });
  }

  confirm = (job) => {
    this.setState({ show: true, job });
  };

  remove = () => {
    const { remove: removeJob } = this.props;
    const { job } = this.state;
    this.setState({ show: false });
    removeJob(job);
  };

  cancel = () => this.setState({ show: false });

  render() {
    const { pending, user, removeJobPending } = this.props;
    const { show, jobs } = this.state;
    if (pending || removeJobPending || !user)
      return <Loader fullScreen vwidth="50vw" show />;
    return (
      <div className="TabbedPanelsContent">
        <Header>
          <HeaderTitle>Jobs</HeaderTitle>
          <div style={{ float: "right", textAlight: "right" }}>
            <div style={{ width: 120, display: "inline-block", marginTop: 14 }}>
              Job credits: {user.job_credits.length}
            </div>
            <PostAJobButton
              to="/employers/post-job"
              className="btn btn-primary btn_apply white_bg"
              style={{ float: "right" }}
            >
              New Job
            </PostAJobButton>
          </div>
        </Header>
        <JobTable confirm={this.confirm} jobs={jobs} pending={pending} />
        <Alert
          title="Are you sure?"
          text="Once deleted, you will not be able to recover this job!"
          type="warning"
          show={show}
          onConfirm={this.remove}
          onCancel={this.cancel}
          showCancelButton
          buttons
          dangerMode
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  jobs: state.getEmployersJobs.jobs,
  removedJob: state.removeJob.job,
  pending: state.getEmployersJobs.pending,
  removeJobPending: state.removeJob.pending,
  user: state.userByToken.user,
  userPending: state.userByToken.pending,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getEmployerJobs: getEmployerJobsAction,
      remove: removeJobAction,
      getUserByToken: getUserByTokenAction,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Jobs);
